import { render, staticRenderFns } from "./follow-item.vue?vue&type=template&id=40a8abd1&"
import script from "./follow-item.vue?vue&type=script&lang=js&"
export * from "./follow-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports